import * as EffectsBuilders from './fx';
import { EffectsRenderBuffer } from '@frontend/lib/fabric/effects/EffectRenderBuffer';

class EffectsPipeline {
  effects = [
    new EffectsBuilders.SkewEffect(),
    new EffectsBuilders.ClippingMaskEffect(),
  ];

  applyEffects(obj, ctx) {
    if (!obj || !obj.canvas) {
      return false;
    }

    if (obj.isClippingMask) {
      return true;
    }

    const renderBuffer = new EffectsRenderBuffer();

    for (const effect of this.effects) {
      if (effect.isActive(obj)) {
        const effectResult = effect.apply(obj, renderBuffer);

        if (effectResult) {
          renderBuffer.update(effectResult);
        }
      }
    }

    if (!renderBuffer.canvas) {
      return false;
    }

    const { canvas, offsetX, offsetY } = renderBuffer;

    if (obj.shadow) {
      const zoom = obj.canvas.getZoom() * obj.canvas.getRetinaScaling();

      ctx.shadowBlur = obj.shadow.blur ? obj.shadow.blur * zoom : 0;
      ctx.shadowOffsetX = obj.shadow.offsetX ? obj.shadow.offsetX * zoom : 0;
      ctx.shadowOffsetY = obj.shadow.offsetY ? obj.shadow.offsetY * zoom : 0;
      ctx.shadowColor = obj.shadow.color || 'rgba(0, 0, 0, 0.5)';
    }

    ctx.drawImage(canvas, obj.left - offsetX, obj.top - offsetY);

    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.shadowColor = 'transparent';

    return true;
  }
}

export const Effects = new EffectsPipeline();
